<template>
  <div class="bgView">
    <div class="addBox">
      
      <header class="addBoxHeader">
        <div class="addBoxTitle">{{isModify?'修改项目':'新增项目'}} </div>
        <img class="closeBtn" :src="closeImg"  @click="cancelBtnClicked"/>
      </header>
      <div class="addBoxBody">
        <div class="addItem">
          <div class="addItemTitle">项目名称</div>
          <input class="addItemInput" v-model="projectName" 
          placeholder="请输入项目名称" maxlength="18"/>
        </div>
       
       
      </div>
      <footer class="addBoxFooter">
        <div class="operationBtn" @click="cancelBtnClicked">取消</div>
        <div class="operationBtn" @click="confirmBtnClicked">确定</div>
      </footer>
    </div>
   
  </div>
  
</template>

<script>
import axios from 'axios'
export default {
  name: 'ProjectAdd',
  props:["isUpdate",
        "selectedProjectId"],
  data () {
    return {
      closeImg: require("../assets/images/clear.png"),
      projectName:'',
      isModify:false
    }
  },
  mounted() {
    console.log(this);
    console.log(this.props);
    // console.log("this.props.isUpdate = ",this.props.isUpdate);
   this.isModify = this.isUpdate;
  },
  methods: {
    cancelBtnClicked() {
      this.$emit("receiveClose")
    },
    confirmBtnClicked(){
      if (this.projectName.length == 0) {
        $alertBox.alert({
          message: "项目名称不能为空!"
        })
        return;
      }

      if (this.isModify) {
        this.updateProject();
      }
      else {
        this.addProject();
      }
      
    },
    addProject() {
     
      let url = baseIp + 'project/addProject'
     
      let param = new FormData();
      param.append("projectName",this.projectName);
      param.append("userId",localStorage.getItem('userId'));
      let config = {
        headers:{
          // 'Content-Type':'application/json; charset=utf-8'
        "token":localStorage.getItem('token'),
        "Access-Control-Allow-Origin":'*'
        }
        
      };
      console.log(url);

      axios.post( url,param,config)
      .then((res)=>{
        console.log(res);
        console.log(res.data); 
    
        if (res.data.code == 200) {
          this.$message({
            type:'success',
            message:'新增成功'
          });
          this.$emit("receiveClose");
        
        }
        else {
           $alertBox.alert({

              message:res.data.message
            })
        }
        

      })
    },
    updateProject() {
      console.log("selectedProjectId",this.selectedProjectId);
      let url = baseIp + 'project/updateProject'
     
      // let param = new FormData();
      // param.append("project",this.projectName);
      // param.append("userId",localStorage.getItem('userId'));
      let json = {
        projectId:this.selectedProjectId,
        projectName:this.projectName
      }
      let param = json;
      let config = {
        headers:{
          'Content-Type':'application/json; charset=utf-8',
        "token":localStorage.getItem('token'),
        "Access-Control-Allow-Origin":'*'
        }
        
      };
      console.log(url);

      axios.post( url,param,config)
      .then((res)=>{
        console.log(res);
        console.log(res.data); 
    
        if (res.data.code == 200) {
          this.$emit("receiveClose");
        
        }
        else {
           $alertBox.alert({

              message:res.data.message
            })
        }
        

      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.bgView {
  width:100%;
  height: 100%;
  top:0px;
  left:0;
  position: fixed;
  background: #000000a0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
}

.addBox {
  width:320px;
  height: auto;
  background: white;
   border-radius: 8px;
}

.addBoxHeader {
  width:100%;
  height: 40px;
  position: relative;
  border-bottom: 1px solid black;
  
}
.addBoxTitle {
  width:100%;
  height:100%;
  position:absolute;
  color: #222226;
  font-size:16px;
  line-height: 40px;
}

.closeBtn {
  width: 20px;
  height: 20px;
  right:20px;
  top:10px;
  position: absolute;
}

.addBoxBody {
  width:calc(100% - 20px);
  height: auto;
  padding:10px;

}

.addItem {
  height: auto;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
 
  margin-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  position: relative;
}
.addItemTitle {
  text-align: left;
  height: 30px;
}
.addItemInput {
  height: 30px;
  border: 1px solid #cccccc;
  border-radius: 2px;
}

.addBoxFooter {
   width:100%;
  height: 40px;
  position: relative;
  border-top: 1px solid black;
   display: flex;
   align-items: center;
}
.operationBtn {
  flex:1 0 0 ;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/ProjectAdd.vue